



















































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Uploads from './Uploads.vue'
import ImageInfos from './imageInfo.vue'
import PageLayout from '@/components/page/PageLayout.vue'
import MsgBoardDialog from '@/components/task/MsgBoardDialog.vue'
import TaskApi from '@/api/task'
import { getTaskType } from '@/utils/order'
import { setViewer } from '@/utils/util'
import Task from '@/web-task'
import moment from 'moment'
let viewer: any = ''
Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteUpdate',
	'beforeRouteLeave',
])

@Component({
	name: 'partnerWorkDetail',
	components: {
		Uploads,
		ImageInfos,
		PageLayout,
		MsgBoardDialog,
	},
})
export default class partnerWorkDetail extends Vue {
	private activeKey = 1
	private expandIconPosition = 'right'
	private data: any = {}
	private mediaInfoList: any = []
	private fileList: any = []
	private videoList: any = []
	private operation: any = {}
	private process: any = 0
	private isCheckResult: boolean = false
	private get taskList() {
		const taskInfo = this.order || {}
		return [
			{
				label: '派单公司',
				value: taskInfo.company,
			},
			{
				label: '订单号',
				value: taskInfo.orderNo,
			},
			{
				label: '报案号',
				value: taskInfo.caseNo,
			},
			{
				label: '所属险种',
				value: this.$store.state.setting.insuranceTypeMap[
					taskInfo.insuranceType
				],
			},
			{
				label: '任务类型',
				value: getTaskType(taskInfo, this.$store.state.setting),
			},
			{
				label: '调查地区',
				value: taskInfo.clinicArea,
			},
			{
				label: '调查地址',
				value: taskInfo.address,
			},
			{
				label: '任务要求',
				value: taskInfo.visitRequest,
			},
			{
				label: '联系人姓名',
				value: taskInfo.linkman,
			},
			{
				label: '联系人电话',
				value: taskInfo.linkmanPhone,
			},
			{
				label: '案件负责人姓名',
				value: taskInfo.contact,
			},
			{
				label: '案件负责人电话',
				value: taskInfo.contactPhone,
			},
		]
	}
	private visiblePass: boolean = false
	private passForm: any = {}
	private order: any = ''
	private injured: any = ''
	private showMsgBoard: boolean = false
	private isWholeProcesDepth: any = ''
	private isInHospital: boolean = false
	private back() {
		this.$router.go(-1)
	}
	private mounted() {
		// this.init()
	}
	private created() {
		this.init()
	}
	private deactivated() {}
	private activated() {
		this.init()
	}
	private beforeRouteUpdate(to: any, from: any, next: any) {
		this.$nextTick(() => {
			this.init()
		})
		next()
	}
	private async init() {
		await this.getDetail()
		this.passForm = this.$form.createForm(this)
	}
	private getDetail() {
		return TaskApi.getTaskDetail(this.$route.params.orderId).then(
			(data: any) => {
				if (data.code === 200) {
					this.data = data.data
					this.order = data.data.order
					const task = new Task({
						propsData: {
							order: this.order,
						},
					})
					this.isWholeProcesDepth = task.isWholeProcesDepth
					this.isInHospital = task.isInHospital
					this.order.endTime = moment(this.order.endTime).format(
						'YYYY-MM-DD HH:mm:ss'
					)
					this.process =
						((this.data.processInfo.baseInfo >= 0
							? this.data.processInfo.baseInfo
							: 0) +
							(this.data.processInfo.media >= 0
								? this.data.processInfo.media
								: 0)) /
						2
					this.operation = this.data.operation
					this.mediaInfoList = this.data.operation.mediaInfoList || []
					this.videoList = this.data.operation.videoList || []
					this.fileList = this.data.operation.fileList || []
				} else if (data.code === 503 && data.message === '权限不足，操作非法') {
					this.$store.dispatch('user/Logout').then(() => {
						window.location.replace(`${location.origin}/passport/login`)
					})
				} else {
					this.$notification.error({
						message: '错误',
						description: data.message,
					})
				}
			}
		)
	}
	// 计算进度
	public getProcess() {
		let num = 0
		this.data.operation.pointList &&
			this.data.operation.pointList.forEach((item: any) => {
				if (item.checkResult) {
					num++
				}
			})
		const baseInfo =
			Math.floor((num * 100) / this.data.operation.pointList.length) || 0
		let mediaNum = 0
		const picList = this.mediaInfoList.filter((item: any) => {
			return item.type == '7001'
		})
		if (picList.length > 3) {
			mediaNum = 3
		} else {
			picList &&
				picList.forEach((item: any) => {
					mediaNum++
				})
		}
		const isZJ = this.mediaInfoList.some(function(item: any) {
			return item.type == '7002'
		})
		const isReport = this.fileList.some(function(item: any) {
			return item.fileType == 'report'
		})
		const isH01 = this.mediaInfoList.some(function(item: any) {
			return item.type == 'h01'
		})
		let media = 0
		if (this.isWholeProcesDepth) {
			if (isZJ) {
				mediaNum++
			}
			if (isReport) {
				mediaNum++
			}
			media = Math.floor((mediaNum * 100) / 5) || 0
		}
		if (this.isInHospital) {
			if (isH01) {
				mediaNum++
			}
			media = Math.floor((mediaNum * 100) / 4) || 0
		}
		if (!(this.isWholeProcesDepth || this.isInHospital)) {
			if (isZJ) {
				mediaNum++
			}
			media = Math.floor((mediaNum * 100) / 4) || 0
		}
		return { baseInfo: baseInfo, media: media }
	}
	// 暂存
	public autoSave() {
		this.setList()
		const processInfo = this.getProcess()
		const data = {
			orderId: this.$route.params.orderId,
			checkResultList: this.data.operation.pointList,
			mediaInfoList: this.mediaInfoList,
			videoList: this.videoList,
			fileList: this.fileList,
			processInfo: processInfo,
		}
		TaskApi.autoSave(data).then((res: any) => {
			this.$message.success('暂存成功')
			this.init()
		})
	}
	// 提交订单
	public submit() {
		this.isCheckResult = true
		const isPoint = this.data.operation.pointList.every((item: any) => {
			return item.checkResult
		})
		if (!isPoint) {
			this.$message.error('请核查回复')
			return
		}
		const isDC = this.mediaInfoList.some(function(item: any) {
			return item.type == '7001'
		})
		const isZJ = this.mediaInfoList.some(function(item: any) {
			return item.type == '7002'
		})
		const isHosp = this.mediaInfoList.some(function(item: any) {
			return item.type == 'h01'
		})
		let mediaNum = 0
		this.mediaInfoList &&
			this.mediaInfoList.forEach((item: any) => {
				if (item.type == '7001') {
					mediaNum++
				}
			})
		if (mediaNum < 3) {
			this.$message.error('请至少上传3张调查过程环境')
			return
		}
		if (!isZJ && !this.isInHospital) {
			this.$message.error('请上传关键证据材料')
			return
		}
		if (!isHosp && this.isInHospital) {
			this.$message.error('请上传关键证据材料')
			return
		}
		const isReport = this.fileList.some(function(item: any) {
			return item.fileType == 'report'
		})
		if (!isReport && this.isWholeProcesDepth) {
			this.$message.error('请上传调查报告')
			return
		}
		this.visiblePass = true
	}
	public upload(data: any) {
		const isImg =
			[
				'7001',
				'7002',
				'7003',
				'0900',
				'h01',
				'h02',
				'h03',
				'h04',
				'h05',
			].indexOf(data.type.toLowerCase()) !== -1
		const isFile = ['report', 'audio'].indexOf(data.type.toLowerCase()) !== -1
		const isVideo = ['0000'].indexOf(data.type.toLowerCase()) !== -1
		if (isImg) {
			if (!data.data || !!data.data.fileId) {
				this.$notification.error({
					message: '错误',
					description: '当前类型仅支持图片上传',
				})
				return
			}
			if (!data.data || !data.data.picId) {
				this.$notification.error({
					message: '错误',
					description: '图片上传失败，请重试',
				})
				return
			}
			this.mediaInfoList.push({
				picId: data.data.picId,
				type: data.type,
				picName: data.picName,
			})
		} else if (isFile) {
			if (!data.data || !!data.data.picId) {
				this.$notification.error({
					message: '错误',
					description:
						'当前类型仅支持PDF、Docx、Doc、xls、xlsx以及录音文件上传',
				})
				return
			}
			if (!data.data || !data.data.fileId) {
				this.$notification.error({
					message: '错误',
					description: '文件上传失败，请重试',
				})
				return
			}
			this.fileList.push({
				fileId: data.data.fileId,
				fileType: data.type,
				fileName: data.picName,
			})
		} else if (isVideo) {
			if (!data || !data.yunFileName) {
				this.$notification.error({
					message: '错误',
					description: '文件上传失败，请重试，请上传视频文件',
				})
				return
			}
			this.videoList.push({
				orginFileName: data.orginFileName,
				yunFileName: data.yunFileName,
				fileLength: -1,
			})
		}
	}
	public remove(data: any) {
		const isImg =
			[
				'7001',
				'7002',
				'7003',
				'0900',
				'h01',
				'h02',
				'h03',
				'h04',
				'h05',
			].indexOf(data.type.toLowerCase()) !== -1
		const isFile = ['report', 'audio'].indexOf(data.type.toLowerCase()) !== -1
		const isVideo = ['0000'].indexOf(data.type.toLowerCase()) !== -1
		if (isImg) {
			this.mediaInfoList &&
				this.mediaInfoList.forEach((item: any, index: any) => {
					if (item.picId == data.data.picId) {
						this.mediaInfoList.splice(index, 1)
					}
				})
		} else if (isFile) {
			this.fileList &&
				this.fileList.forEach((item: any, index: any) => {
					if (item.fileId == data.data.fileId) {
						this.fileList.splice(index, 1)
					}
				})
		} else if (isVideo) {
			this.videoList &&
				this.videoList.forEach((item: any, index: any) => {
					if (item.yunFileName == data.data.yunFileName) {
						this.videoList.splice(index, 1)
					}
				})
		}
	}
	private openImg(val: any) {
		if (val) {
			this.$nextTick(() => {
				if (val) {
					const dom = document.querySelector('#images')
					if (dom) {
						viewer = setViewer(dom, viewer)
					}
				}
			})
		}
	}

	private handleCancel() {
		this.visiblePass = false
	}
	private setList() {
		this.videoList &&
			this.videoList.forEach((item: any, index: any) => {
				item.orderNum = index + 1
			})
		const reportList = this.fileList.filter((item: any) => {
			return item.fileType == 'report'
		})
		const audioList = this.fileList.filter((item: any) => {
			return item.fileType == 'audio'
		})
		reportList &&
			reportList.forEach((item: any, index: any) => {
				item.orderNum = index + 1
			})
		audioList &&
			audioList.forEach((item: any, index: any) => {
				item.orderNum = index + 1
			})
		this.fileList.forEach((item: any) => {
			reportList.forEach((items: any) => {
				if (item.fileId == items.fileId) {
					item.orderNum = items.orderNum
				}
			})
			audioList &&
				audioList.forEach((items: any) => {
					if (item.fileId == items.fileId) {
						item.orderNum = items.orderNum
					}
				})
		})
		const oneList = this.mediaInfoList.filter((item: any) => {
			return item.type == '7001'
		})
		oneList &
			oneList.forEach((item: any, index: any) => {
				item.orderNum = index + 1
			})
		const twoList = this.mediaInfoList.filter((item: any) => {
			return item.type == '7002'
		})
		twoList &
			twoList.forEach((item: any, index: any) => {
				item.orderNum = index + 1
			})
		const threeList = this.mediaInfoList.filter((item: any) => {
			return item.type == '7002'
		})
		threeList &
			threeList.forEach((item: any, index: any) => {
				item.orderNum = index + 1
			})
		const fourList = this.mediaInfoList.filter((item: any) => {
			return item.type == '0900'
		})
		fourList &
			fourList.forEach((item: any, index: any) => {
				item.orderNum = index + 1
			})
		const h01 = this.mediaInfoList.filter((item: any) => {
			return item.type == 'h01'
		})
		h01 &
			h01.forEach((item: any, index: any) => {
				item.orderNum = index + 1
			})
		const h02 = this.mediaInfoList.filter((item: any) => {
			return item.type == 'h02'
		})
		h02 &
			h02.forEach((item: any, index: any) => {
				item.orderNum = index + 1
			})
		const h03 = this.mediaInfoList.filter((item: any) => {
			return item.type == 'h03'
		})
		h03 &
			h03.forEach((item: any, index: any) => {
				item.orderNum = index + 1
			})
		const h04 = this.mediaInfoList.filter((item: any) => {
			return item.type == 'h04'
		})
		h04 &
			h04.forEach((item: any, index: any) => {
				item.orderNum = index + 1
			})
		const h05 = this.mediaInfoList.filter((item: any) => {
			return item.type == 'h05'
		})
		h05 &
			h05.forEach((item: any, index: any) => {
				item.orderNum = index + 1
			})
		this.mediaInfoList &&
			this.mediaInfoList.forEach((item: any, index: any) => {
				oneList.forEach((items: any) => {
					if (item.picId == items.picId) {
						item.orderNum = items.orderNum
					}
				})
				twoList.forEach((items: any) => {
					if (item.picId == items.picId) {
						item.orderNum = items.orderNum
					}
				})
				threeList &&
					threeList.forEach((items: any) => {
						if (item.picId == items.picId) {
							item.orderNum = items.orderNum
						}
					})
				fourList &&
					fourList.forEach((items: any) => {
						if (item.picId == items.picId) {
							item.orderNum = items.orderNum
						}
					})
				h01 &&
					h01.forEach((items: any) => {
						if (item.picId == items.picId) {
							item.orderNum = items.orderNum
						}
					})
				h02 &&
					h02.forEach((items: any) => {
						if (item.picId == items.picId) {
							item.orderNum = items.orderNum
						}
					})
				h03 &&
					h03.forEach((items: any) => {
						if (item.picId == items.picId) {
							item.orderNum = items.orderNum
						}
					})
				h04 &&
					h04.forEach((items: any) => {
						if (item.picId == items.picId) {
							item.orderNum = items.orderNum
						}
					})
				h05 &&
					h05.forEach((items: any) => {
						if (item.picId == items.picId) {
							item.orderNum = items.orderNum
						}
					})
			})
	}
	private handleOk() {
		this.passForm.validateFields((err: any, values: any) => {
			if (!err) {
				this.setList()
				const data = {
					orderId: this.$route.params.orderId,
					checkResultList: this.data.operation.pointList,
					mediaInfoList: this.mediaInfoList,
					videoList: this.videoList,
					fileList: this.fileList,
					insufficiency: values.insufficiency,
					insufficiencyRemark: values.insufficiencyRemark,
				}
				console.log(data, 'data')
				TaskApi.Save(data).then((res: any) => {
					this.$message.success('提交成功')
					this.visiblePass = false
					this.$multiTab.closeCurrentPage()
					setTimeout(() => {
						this.$multiTab.open(`/partner/order/orderList`)
					}, 1000)
				})
			}
		})
	}
	private insufficiencyChange(e: any) {
		this.passForm.insufficiency = e.target.value
	}
	private checkResultChange() {
		this.isCheckResult = false
	}
}
